import {
  ActivityPlayer as ActivityPlayerRoot,
  type ActivityPlayerProps,
} from "./ActivityPlayer";
import {
  ActivityPlayerContent,
  type ActivityPlayerContentProps,
} from "./ActivityPlayerContent";
import {
  ActivityPlayerFooter,
  type ActivityPlayerFooterProps,
} from "./ActivityPlayerFooter";
import {
  ActivityPlayerHeader,
  type ActivityPlayerHeaderProps,
} from "./ActivityPlayerHeader";
import {
  ActivityPlayerNextButton,
  type ActivityPlayerNextButtonProps,
} from "./ActivityPlayerNextButton";
import {
  ActivityPlayerPreviousButton,
  type ActivityPlayerPreviousButtonProps,
} from "./ActivityPlayerPreviousButton";

export {
  ActivityPlayerContentProps,
  ActivityPlayerFooterProps,
  ActivityPlayerHeaderProps,
  ActivityPlayerNextButtonProps,
  ActivityPlayerPreviousButtonProps,
  ActivityPlayerProps,
};
export * from "./hooks";

export const ActivityPlayer = Object.assign(ActivityPlayerRoot, {
  Header: ActivityPlayerHeader,
  Content: ActivityPlayerContent,
  Footer: ActivityPlayerFooter,
  PreviousButton: ActivityPlayerPreviousButton,
  NextButton: ActivityPlayerNextButton,
});
